import axios from "axios";
import { Base_URL } from "../url";

export const fetchItemTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemTypeMaster/GetAllItemTypes`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item types!";
  }
};

export const downloadItemTypesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemTypeMaster/DownloadItemTypesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading item types data!";
  }
};